import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';

import './SellAllSharesClosedToNewInvestors.scss';

import Button from '../../Shared/Button/Button';
import { moduleActions } from 'src/redux/modules';
import { scrollElementIntoFullView } from 'src/utils/dom-utils';
import { updateExchangeFund } from '../../../redux/modules/exchangeTransaction/exchangeTransaction.module';

import { updateSellFund } from '../../../redux/modules/sellTransaction/sellTransaction.module';

class ConfirmIRADistributionModal extends Component {
  render() {
    const {
      fund: { agreementID },
      proceed,
      closeModal,
    } = this.props;
    return (
      <div className="e2e-sell-all-shares-closed-to-new-investors-container">
        <div className="sell-all-shares-closed-to-new-investors-heading">
          IRA Distribution Event
        </div>

        <div className="sell-all-shares-closed-to-new-investors-disclosure">
          By selecting to exchange from a retirement registration type to a
          non-retirement registration type, you are requesting a redemption and
          a purchase transaction. This is a tax reportable event and there could
          be unintended tax consequences. If this is not your intended
          transaction, please review and adjust your selection. If this is your
          intended transaction, please confirm below.
        </div>

        <div className="sell-all-shares-closed-to-new-investors-button-container">
          <a
            className="trp-pdf-link e2e-sell-all-shares-closed-to-new-investors-cancel-button sell-all-shares-closed-to-new-investors-cancel-button"
            id="e2e-sell-all-shares-closed-to-new-investors-modal-cancel"
            onClick={() => {
              closeModal();
            }}
          >
            Return to Transaction
          </a>

          <Button
            buttonType="primary"
            className="btn-trp-primary e2e-sell-all-shares-closed-to-new-investors-confirm-button sell-all-shares-closed-to-new-investors-confirm-button"
            id={`sell-all-shares-closed-to-new-investors-modal-ok-btn-${agreementID}`}
            onClick={() => {
              proceed();
              closeModal();
            }}
            stylename="sell-all-shares-closed-to-new-investors-ok-button"
          >
            Proceed with IRA Distribution
          </Button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      ...bindActionCreators(
        {
          updateSellFund,
          updateExchangeFund,
        },
        dispatch
      ),
      setProgress: (step) => {
        scrollElementIntoFullView(`step${step}`);
        dispatch(moduleActions.setProgress(step));
      },
    },
  };
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  ConfirmIRADistributionModal
);
